import React, {useEffect} from 'react';
import '../styles/About.css'; // You can create this file for specific styling

const About = () => {
    
    useEffect(() => {
        document.title = 'About Us | Bularis Tech';
    }, []);
      
  return (
    <div className="about">
      <div className="about-header">
        <h1>About Us</h1>
        <p>Learn more about our mission and values.</p>
      </div>
      <div className="about-content">
        <h2>Who We Are</h2>
        <p>We are a tech company focused on providing quality solutions for web and mobile applications, e-commerce, and more.</p>
      </div>
      <div className="about-mission">
        <h2>Our Mission</h2>
        <p>To innovate and deliver exceptional technology solutions that drive success for businesses and individuals.</p>
      </div>
    </div>
  );
}

export default About;
